import WorkOrder from 'shared/interfaces/WorkOrder.interface';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'shared/store/rootReducer';
import { setSelectedWorkOrders } from 'shared/store/features/workOrdersTableSlice';

const useBillingTableLogic = () => {
  const dispatch = useDispatch();
  const { selectedWorkOrders } = useSelector(
    (state: RootState) => state.workOrdersTable
  );
  const { isTableLoaderVisible } = useSelector(
    (state: RootState) => state.tableLoader
  );
  const { workOrders } = useSelector(
    (state: RootState) => state.workOrders
  );

  const setRowsSelected = (selectedRows: WorkOrder[]) => {
    dispatch(setSelectedWorkOrders({ selectedWorkOrders: selectedRows }));
  };

  const activeRowHandler = (row: WorkOrder, checked: boolean) => {
    const selectedRows = checked ? [...selectedWorkOrders, row] : selectedWorkOrders.filter(item => item !== row);
    setRowsSelected(selectedRows);
  };

  const activeAllRows = (rows: WorkOrder[], checked: boolean) => (
    checked ? setRowsSelected(rows) : setRowsSelected([])
  );
  
  return {
    activeRowHandler,
    activeAllRows,
    selectedWorkOrders,
    workOrders,
    setRowsSelected,
    isTableLoaderVisible
  };
};

export default useBillingTableLogic;
